"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All user related translations
var User = {
  which_activities_mail: {
    nl: 'Van welke activiteiten wil jij een mail ontvangen?',
    fr: 'De quelles activités souhaitez-vous recevoir un e-mail?',
    en: 'From which activities do you want to receive an email?'
  },
  team_graphic_activities: {
    nl: 'Activiteiten van het grafische team',
    fr: 'Activités de l\'équipe graphique',
    en: 'Activities of the graphic team'
  },
  team_developers_activities: {
    nl: 'Activiteiten van het developers team',
    fr: 'Activités de l\'équipe de développeurs',
    en: 'Activities of the developers team'
  },
  team_sales_activities: {
    nl: 'Activiteiten van het sales team',
    fr: 'Activités de l\'équipe commerciale',
    en: 'Activities of the sales team'
  },
  basically_who_you_are: {
    nl: 'Dit is wie je bent.',
    fr: 'C\'est qui vous êtes.',
    en: 'This is basically who you are.'
  },
  change_or_remove_avatar: {
    nl: 'Wijzig of verwijder hier uw avatar.',
    fr: 'Modifiez ou supprimez votre avatar ici.',
    en: 'Change or remove your avatar here.'
  }
};
var _default = User;
exports["default"] = _default;